module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "featured"
  }, [_c('div', {
    staticClass: "row results-row"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.reverse), function(pos) {
    return _c('div', {
      staticClass: "col-md-offset-2 col-md-8 col-xs-10 col-xs-offset-1"
    }, [_c('md-card', {
      staticClass: "md-primary",
      attrs: {
        "flex": "",
        "md-with-hover": "",
        "md-elevation": "15"
      }
    }, [_c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v("Work with " + _vm._s(pos.Organisation))]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                    Commitment: " + _vm._s(pos.Commitment)), _c('br'), _vm._v("\n                    Work in " + _vm._s(pos.City) + " "), _c('br'), _vm._v("\n                    Category: " + _vm._s(pos.Category) + "\n                                      ")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('md-card-expand', [_c('md-card-actions', [_c('md-button', {
      staticClass: "theme",
      attrs: {
        "href": pos.Form,
        "target": "_blank"
      }
    }, [_vm._v("Apply")]), _vm._v(" "), _c('md-button', {
      staticClass: "theme",
      attrs: {
        "md-expand-trigger": ""
      }
    }, [_vm._v("\n                      More Info\n                    ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "flex": "1"
      }
    })], 1), _vm._v(" "), _c('md-card-content', [_vm._v(" \n                    " + _vm._s(pos.Description) + "\n                  ")])], 1)], 1)], 1)
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " col-md-12 col-xs-12"
  }, [_c('h3', {
    staticClass: "title-text text-center"
  }, [_vm._v(" Recent Opportunities ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01c2e7ea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Featured.vue
// module id = 890
// module chunks = 1